import _asyncToGenerator from "/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/regenerator";
import { delay } from '../timers';
import { isObject } from 'lodash';
var RETRY_DELAY = 10000; // when socket cannot connect, the time to retry

var DEFAULT_TIMEOUT = 5000; // timeout for sendData

var NO_WEBSOCKET_SUPPORT = 'This browser does not support websockets';
var NO_URL_DEFINED = 'No websocket url defined during construction';
var browserWindow; // eslint-disable-next-line func-names

(function (win) {
  browserWindow = win;
})(typeof global !== 'undefined' ? global :
/* istanbul ignore next */
this);

var Ws = /*#__PURE__*/function () {
  function Ws(url) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Ws);

    this.url = url;

    if (typeof config.onOpen === 'function') {
      this.onOpen = config.onOpen;
    }

    if (typeof config.onData === 'function') {
      this.onData = config.onData;
    }

    if (typeof config.onClose === 'function') {
      this.onClose = config.onClose;
    }

    if (typeof config.onError === 'function') {
      this.onError = config.onError;
    }

    try {
      this.ensureConnection(); // do not await, just initialize
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }
  }

  _createClass(Ws, [{
    key: "connect",
    value: function connect(withDelay) {
      var _this = this;

      // eslint-disable-next-line no-async-promise-executor
      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(resolve) {
          var retryConnection, onData, onClose, onError, onOpen;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!withDelay) {
                    _context3.next = 3;
                    break;
                  }

                  _context3.next = 3;
                  return delay(RETRY_DELAY);

                case 3:
                  onData = function onData(event) {
                    if (_this.onData && event.data) {
                      // try to parse the data, in case it is an object:
                      var data;

                      try {
                        data = JSON.parse(event.data);
                      } catch (err) {
                        data = event.data;
                      }

                      _this.onData(data);
                    }
                  };

                  onClose = /*#__PURE__*/function () {
                    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(msg) {
                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              retryConnection();
                              _this.connected = _this.connect(true);

                              if (_this.onClose) {
                                _this.onClose(msg);
                              }

                            case 3:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                    return function onClose(_x2) {
                      return _ref2.apply(this, arguments);
                    };
                  }();

                  onError = /*#__PURE__*/function () {
                    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(err) {
                      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              retryConnection();
                              resolve(_this.connect(true));

                              if (_this.onError) {
                                _this.onError(err);
                              }

                            case 3:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      }, _callee2);
                    }));

                    return function onError(_x3) {
                      return _ref3.apply(this, arguments);
                    };
                  }(); // Connection opened


                  onOpen = function onOpen() {
                    _this.websocket.addEventListener('close', onClose);

                    _this.websocket.addEventListener('message', onData);

                    resolve();

                    if (_this.onOpen) {
                      _this.onOpen();
                    }
                  };

                  retryConnection = function retryConnection() {
                    _this.websocket.removeEventListener('close', onClose);

                    _this.websocket.removeEventListener('message', onData);

                    _this.websocket.removeEventListener('open', onOpen);

                    _this.websocket.removeEventListener('error', onError);
                  }; // Create WebSocket connection.


                  try {
                    _this.websocket = new browserWindow.WebSocket(_this.url);
                  } catch (err) {
                    onError(err);
                  }

                  _this.websocket.addEventListener('open', onOpen);

                  _this.websocket.addEventListener('error', onError);

                case 11:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "ensureConnection",
    value: function () {
      var _ensureConnection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (browserWindow.WebSocket) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return", Promise.reject(NO_WEBSOCKET_SUPPORT));

              case 2:
                if (this.url) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt("return", Promise.reject(NO_URL_DEFINED));

              case 4:
                if (!this.connected) {
                  this.connected = this.connect();
                }

                return _context4.abrupt("return", this.connected);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function ensureConnection() {
        return _ensureConnection.apply(this, arguments);
      }

      return ensureConnection;
    }()
  }, {
    key: "sendData",
    value: function sendData(data) {
      var _this2 = this;

      var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_TIMEOUT;

      if (browserWindow.WebSocket) {
        if (isObject(data)) {
          data = JSON.stringify(data);
        } // eslint-disable-next-line no-async-promise-executor


        return new Promise( /*#__PURE__*/function () {
          var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(resolve, reject) {
            var timeoutID;
            return _regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    if (timeout) {
                      // eslint-disable-next-line prefer-promise-reject-errors
                      timeoutID = setTimeout(function () {
                        return reject('request timeout');
                      }, timeout);
                    }

                    _context5.prev = 1;
                    _context5.next = 4;
                    return _this2.ensureConnection();

                  case 4:
                    clearTimeout(timeoutID);
                    resolve();
                    _context5.next = 11;
                    break;

                  case 8:
                    _context5.prev = 8;
                    _context5.t0 = _context5["catch"](1);
                    reject(_context5.t0.message);

                  case 11:
                    _this2.websocket.send(data);

                  case 12:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5, null, [[1, 8]]);
          }));

          return function (_x4, _x5) {
            return _ref4.apply(this, arguments);
          };
        }());
      }

      return Promise.reject(NO_WEBSOCKET_SUPPORT);
    }
  }]);

  return Ws;
}();

export default Ws;